import { Text } from "@prophero-ds/cx-react";

import { useMediaQuery } from "@/hooks/useMediaQuery";
import { MEDIA_QUERY } from "@/utils/mediaQueries";

type PasswordHeaderProps = {
  title: string;
  description: string;
};

function PasswordHeader({ title, description }: PasswordHeaderProps) {
  const isDesktop = useMediaQuery(MEDIA_QUERY.desktop);

  return (
    <div className="flex flex-col gap-2">
      <Text as="h1" variant={isDesktop ? "h1" : "h2"}>
        {title}
      </Text>
      <Text as="p" variant="body2" color="secondary">
        {description}
      </Text>
    </div>
  );
}

export default PasswordHeader;
